/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/first */
import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import Clsx from "clsx";
import Helper from "utils/Helper";
import Img from "react-cool-img";
import Measure from "react-measure";
import Slider from "react-slick";
import CountUp from "react-countup";
import LazyLoad from "react-lazyload";
import VisibilitySensor from "react-visibility-sensor";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Component
import Container from "@material-ui/core/Container";
import Tooltip from "@material-ui/core/Tooltip";
import Header from "components/share/Header";
import Footer from "components/share/Footer";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CreatorCard from "components/share/CreatorCard";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

// Icons
import InstagramIcon from "mdi-react/InstagramIcon";

//API
import MemoAPI from "services/MemoAPI";

// Assets
import styles from "./home-style";
const useStyles = makeStyles(styles);
const func = () => {};

import Home1 from "assets/background/home1.png";
import Home2 from "assets/background/home2.png";
import Home3 from "assets/background/home3.webp";

import About1 from "assets/about1.webp";
import About2 from "assets/about2.webp";
import About3 from "assets/about3.webp";

import Prod1 from "assets/prod/prod1.webp";
import Prod2 from "assets/prod/prod2.webp";
import Prod3 from "assets/prod/shop.png";
import Prod4 from "assets/prod/prod4.webp";
import Prod5 from "assets/prod/prod5.webp";
import Prod6 from "assets/prod/pod.png";

import BrandList from "assets/brandlist.webp";

import SiteMap from "assets/sitemap.webp";

const mailFields = {
	name: "name",
	phone: "phone",
	email: "email",
	content: "content",
};

const prodImgs = [
	{
		src: Prod1,
		text: "主題限定",
		link: "https://creator.memopresso.com/",
	},
	{
		src: Prod2,
		text: "插畫家相片框",
		link: "https://creator.memopresso.com/frame/tag/weekHot",
	},
	{
		src: Prod3,
		text: "個性化商品",
		link: "https://creatify.tw/",
	},
	{
		src: Prod4,
		text: "異業合作",
		link: "https://medium.com/memopresso/tagged/%E5%93%81%E7%89%8C%E5%90%88%E4%BD%9C",
	},
	{
		src: Prod5,
		text: "機台租賃",
		link: "https://medium.com/memopresso",
	},
	{
		src: Prod6,
		text: "客製服務介紹",
		link: "https://medium.com/memopresso/tagged/print-on-demand",
	},
];

const aboutTxt1 = [
	"藉由智慧零售製作與分享個性化回憶",
	"將美好時光實體化",
	"透過手握，感受回憶散發的溫度",
	"不再給予照片枷鎖，僅封存於手機相簿",
	"活化所有回憶，跳脫數位框架",
	"打造”有感社交“的社群分享體驗",
];

const aboutTxt2 = [
	"透過個性化軟體與機台的軟硬體結合",
	"打造無人零售的商業模式",
	"與社群媒體互聯，無需額外下載圖片",
	"亦可線上編輯，線下取貨",
	"再也不擔心排隊人潮的壓力",
	"在快節奏的時代下提供快速保存的解決方案",
];

const Home = (props) => {
	const classes = useStyles(props);
	const history = useHistory();

	const [dimensions, setDimensions] = useState({});
	const [message, setMessage] = useState({});
	const { name = "", phone = "", email = "", content = "" } = message;
	const [creators, setCreators] = useState([]);
	const { width = 0, height = 0 } = dimensions;
	const { width: screenWidth } = Helper.GetScreenSize();

	useEffect(() => {
		getCreatorList();
	}, []);

	const getCreatorList = async () => {
		try {
			const list = await MemoAPI.GetCreators();
			console.log(list);
			setCreators(list.slice(0, 8));
		} catch (error) {
			console.log("getCreatorList : ", error);
		}
	};

	const handleChange = (e, key) => {
		const value = e.target.value;
		setMessage({
			...message,
			[key]: value,
		});
	};

	const sendMail = async () => {
		try {
			if (!name || !phone || !email || !content) {
				toast.error("欄位尚未填寫");
				return;
			}

			await MemoAPI.SendMail(message);
			toast.success("訊息傳送成功！");
			setMessage({});
		} catch (error) {
			console.log(error);
			toast.error("訊息傳送失敗");
		}
	};

	const renderHome = () => {
		const settings = {
			dots: true,
			infinite: true,
			speed: 1000,
			autoplaySpeed: 5000,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		return (
			<div className={classes.homeSection}>
				<Slider {...settings}>
					<>
						<div style={getStyle(Home1)}>
							<Box
								style={{
									position: "absolute",
									top: "40%",
									right: "15%",
									color: "black",
								}}
								display={{ xs: "none", md: "block" }}
							>
								<Box
									style={{
										color: "white",
										fontSize: 50,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										color: "white",
										fontSize: 23.5,
										fontWeight: 600,
										textShadow: "1px 1px 2px black",
									}}
								>
									列印你的美好回憶
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									mt={5}
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											width: 200,
											height: 40,
											fontSize: 20,
											fontWeight: 900,
											borderRadius: 8,
											backgroundColor: "#f1b787",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://creator.memopresso.com/`,
												"_blank"
											);
										}}
									>
										立即製作
									</Button>
								</Box>
							</Box>

							<Box
								className={classes.homeTitleMB}
								display={{ xs: "block", md: "none" }}
							>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 25,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 18,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									ONLINE SHOP
								</Box>
								<Box
									mt={3}
									display="flex"
									justifyContent="center"
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											width: 200,
											height: 40,
											fontSize: 20,
											fontWeight: 900,
											borderRadius: 8,
											backgroundColor: "#f1b787",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://creator.memopresso.com/`,
												"_blank"
											);
										}}
									>
										立即製作
									</Button>
								</Box>
							</Box>
						</div>
					</>
					<>
						<div style={getStyle(Home2)}>
							<Box
								style={{
									position: "absolute",
									top: "30%",
									right: "15%",
									color: "black",
								}}
								display={{ xs: "none", md: "block" }}
							>
								<Box
									style={{
										color: "black",
										fontSize: 50,
										fontWeight: 900,
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									display="flex"
									justifyContent="flex-end"
									style={{
										color: "black",
										fontSize: 32,
										fontWeight: 600,
									}}
								>
									ONLINE SHOP
								</Box>
								<Box
									mt={3}
									display="flex"
									justifyContent="flex-end"
									style={{
										color: "black",
										fontSize: 24,
										fontWeight: 400,
									}}
								>
									想印照片，不管晴天下雨
								</Box>
								<Box
									display="flex"
									justifyContent="flex-end"
									style={{
										marginTop: 50,
										color: "black",
										fontSize: 24,
										fontWeight: 400,
									}}
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											color: "black",
											width: 200,
											height: 40,
											fontSize: 20,
											fontWeight: 900,
											borderRadius: 8,
											backgroundColor: "#fffbea",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://creator.memopresso.com/`,
												"_blank"
											);
										}}
									>
										前往線上商店
									</Button>
								</Box>
							</Box>

							<Box
								className={classes.homeTitleMB}
								display={{ xs: "block", md: "none" }}
							>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 25,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 18,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									ONLINE SHOP
								</Box>
								<Box
									mt={2}
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 16,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									想印照片，不管晴天下雨
								</Box>
								<Box
									mt={3}
									display="flex"
									justifyContent="center"
									style={{
										color: "black",
										fontSize: 24,
										fontWeight: 400,
									}}
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											color: "black",
											width: 200,
											height: 40,
											fontSize: 20,
											fontWeight: 900,
											borderRadius: 8,
											backgroundColor: "#fffbea",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://creator.memopresso.com/`,
												"_blank"
											);
										}}
									>
										前往線上商店
									</Button>
								</Box>
							</Box>
						</div>
					</>
					<>
						<div style={getStyle(Home3, "center top")}>
							<Box
								style={{
									position: "absolute",
									top: "35%",
									left: "10%",
									color: "black",
								}}
								display={{ xs: "none", md: "block" }}
							>
								<Box
									style={{
										fontSize: 45,
										fontWeight: 900,
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									style={{
										fontSize: 32,
										fontWeight: 600,
									}}
								>
									CREATORS MARKET
								</Box>
								<Box
									mt={3}
									style={{
										fontSize: 24,
										fontWeight: 400,
									}}
								>
									只要你有才，伯樂已經在等你。
								</Box>
								<Box
									style={{
										fontSize: 45,
										fontWeight: 900,
									}}
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											marginTop: 40,
											width: 150,
											height: 40,
											fontSize: 18,
											borderRadius: 8,
											backgroundColor: "#f8adb4",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://studio.memopresso.com/`,
												"_blank"
											);
										}}
									>
										成為創作者
									</Button>
								</Box>
							</Box>

							<Box
								className={classes.homeTitleMB}
								display={{ xs: "block", md: "none" }}
							>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 25,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									MEMOPRESSO
								</Box>
								<Box
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 18,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									CREATORS MARKET
								</Box>
								<Box
									mt={1}
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 16,
										fontWeight: 900,
										textShadow: "1px 1px 2px black",
									}}
								>
									只要你有才，伯樂已經在等你。
								</Box>
								<Box
									mt={3}
									display="flex"
									justifyContent="center"
									style={{
										fontSize: 25,
										fontWeight: 900,
									}}
								>
									<Button
										variant="contained"
										color="primary"
										style={{
											width: 150,
											height: 40,
											fontSize: 18,
											borderRadius: 8,
											backgroundColor: "#f8adb4",
										}}
										size="large"
										onClick={() => {
											window.open(
												`https://studio.memopresso.com/`,
												"_blank"
											);
										}}
									>
										成為創作者
									</Button>
								</Box>
							</Box>
						</div>
					</>
				</Slider>
			</div>
		);

		function getStyle(image, position = "") {
			return {
				position: "relative",
				backgroundImage: `url(${image})`,
				WebkitBackgroundSize: "cover",
				MozBackgroundSize: "cover",
				backgroundSize: "cover",
				backgroundPosition: position,
				height: "73vh",
				marginTop: -20,
			};
		}
	};

	const renderProds = () => {
		const settings = {
			dots: true,
			infinite: true,
			speed: 1000,
			autoplaySpeed: 5000,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		return (
			<Box id="prods" className={classes.productSection}>
				<Container maxWidth="lg">
					<Box
						display="flex"
						justifyContent="center"
						className={classes.title}
					>
						MEMOPRESSO 產品
					</Box>
					<Box
						display="flex"
						className={classes.subTitle}
						justifyContent="center"
					>
						Products of MEMOPRESSO
					</Box>
					<Box display="flex" justifyContent="center" mt={3}>
						<div className={classes.desc}>
							MEMOPRESSO 透過智慧零售與 OMO
							(Offline-Merge-Online)模式提供嶄新的回憶保存方式
							從文青風格的純白相框，或是套用上百種插畫家設計
							甚至期間限定的偶像合作，拉近你與偶像的距離
							都能創造屬於自己的個性化回憶，保存有價值的美好時光
						</div>
					</Box>

					<Box py={5} display={{ xs: "none", md: "block" }}>
						<Grid container spacing={3}>
							{_.map(prodImgs, ({ src, text, link }, index) => (
								<Grid
									item
									xs={12}
									sm={6}
									md={4}
									key={`prod_img_${index}`}
									style={{ marginBottom: 12 }}
								>
									<div style={{ position: "relative" }}>
										<Img
											className={classes.image}
											style={{ zIndex: 0 }}
											placeholder={src}
											src={src}
											error={src}
											alt={`prod_img_${index}`}
										/>
										<div
											className={classes.productHover}
											onClick={() => {
												window.open(link, "_blank");
											}}
										>
											<Box
												className={
													classes.productionText
												}
												display="flex"
												justifyContent="center"
											>
												{text}
											</Box>
										</div>
									</div>
								</Grid>
							))}
						</Grid>
					</Box>

					<Box px={3} py={5} display={{ xs: "block", md: "none" }}>
						<Slider {...settings}>
							{_.map(prodImgs, ({ src, text, link }, index) => (
								<div
									item
									key={`prod_img_${index}`}
									style={{ marginBottom: 12 }}
								>
									<div style={{ position: "relative" }}>
										<Img
											className={classes.image}
											style={{ zIndex: 0 }}
											placeholder={src}
											src={src}
											error={src}
											alt={`prod_img_${index}`}
										/>
										<div
											className={classes.productHover}
											onClick={() => {
												window.open(link, "_blank");
											}}
										>
											<Box
												className={
													classes.productionText
												}
												display="flex"
												justifyContent="center"
											>
												{text}
											</Box>
										</div>
									</div>
								</div>
							))}
						</Slider>
					</Box>
				</Container>
			</Box>
		);
	};

	const renderEmbed = (width, height, src = "") => {
		return (
			<LazyLoad height={height}>
				<iframe
					width={width}
					height={height}
					src={src}
					frameBorder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>
			</LazyLoad>
		);
	};

	const renderOperation = () => {
		return (
			<Box pt={5} id="howtouse" className={classes.opSection}>
				<Container maxWidth="lg" style={{ padding: 0 }}>
					<Box
						display="flex"
						justifyContent="center"
						className={classes.title}
					>
						線下&線上操作系統
					</Box>
					<Box
						display="flex"
						className={classes.subTitle}
						justifyContent="center"
					>
						OFFLINE & ONLINE SYSTEM
					</Box>

					{/* 桌機版 */}
					<Box pt={5} display={{ xs: "none", md: "block" }}>
						<Grid container>
							<Grid item xs={12} sm={12} md={6}>
								<Measure
									bounds
									onResize={(contentRect) => {
										setDimensions(contentRect.bounds);
									}}
								>
									{({ measureRef }) => (
										<div ref={measureRef}>
											<div
												className={
													classes.productGradient
												}
												style={{
													paddingTop: 80,
													paddingLeft: 40,
													width: "100%",
												}}
											>
												<div
													style={{
														fontSize: 81,
														color: "white",
														fontWeight: 900,
														lineHeight: "40%",
													}}
												>
													OFFLINE
												</div>
												<div
													style={{
														fontSize: 84,
														color: "white",
														fontWeight: 900,
														paddingLeft: 100,
													}}
												>
													SYSTEM
												</div>
												<div
													style={{
														paddingTop: 40,
														paddingBottom: 40,
														color: "white",
														width: "100%",
														fontSize: 24,
														fontWeight: 400,
													}}
												>
													使用機器→上傳照片→選擇相框→付款列印
												</div>
											</div>
										</div>
									)}
								</Measure>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={6}
								style={{ height }}
							>
								{renderEmbed(
									"100%",
									height,
									"https://www.youtube.com/embed/VAi7KHzGQEw"
								)}
							</Grid>
						</Grid>
						<Grid container>
							<Grid item xs={12} sm={12} md={6}>
								{renderEmbed(
									"100%",
									height,
									"https://www.youtube.com/embed/SzwszH5sgiw"
								)}
							</Grid>
							<Grid item xs={12} sm={12} md={6}>
								<div
									className={classes.productGradient}
									style={{
										paddingTop: 80,
										paddingLeft: 40,
										width: "100%",
									}}
								>
									<div
										style={{
											fontSize: 81,
											color: "white",
											fontWeight: 900,
											lineHeight: "40%",
											paddingLeft: 100,
										}}
									>
										ONLINE
									</div>
									<div
										style={{
											fontSize: 84,
											color: "white",
											fontWeight: 900,
										}}
									>
										SYSTEM
									</div>
									<div
										style={{
											paddingTop: 40,
											paddingBottom: 40,
											color: "white",
											width: "100%",
											fontSize: 24,
											fontWeight: 400,
										}}
									>
										社群帳號→上傳照片→選擇相框→付款條碼
									</div>
								</div>
							</Grid>
						</Grid>
					</Box>
					{/* 手機版 */}
					<Box pt={5} display={{ xs: "block", md: "none" }}>
						<div
							className={classes.productGradient}
							style={{
								padding: 24,
								width: "100%",
								fontSize: 36,
								color: "white",
								fontWeight: 900,
							}}
						>
							OFFLINE SYSTEM
							<div
								style={{
									paddingTop: 24,
									paddingBottom: 24,
									fontSize: 18,
									fontWeight: 400,
								}}
							>
								使用機器→上傳照片→選擇相框→付款列印
							</div>
						</div>
						{renderEmbed(
							"100%",
							300,
							"https://www.youtube.com/embed/SzwszH5sgiw"
						)}
						<div
							className={classes.productGradient}
							style={{
								padding: 24,
								width: "100%",
								fontSize: 36,
								color: "white",
								fontWeight: 900,
							}}
						>
							ONLINE SYSTEM
							<div
								style={{
									paddingTop: 24,
									paddingBottom: 24,
									fontSize: 18,
									fontWeight: 400,
									width: "100%",
								}}
							>
								社群帳號→上傳照片→選擇相框→付款條碼
							</div>
						</div>
						{renderEmbed(
							"100%",
							300,
							"https://www.youtube.com/embed/VAi7KHzGQEw"
						)}
					</Box>
				</Container>
			</Box>
		);
	};

	const renderCreators = () => {
		const settings = {
			dots: true,
			infinite: true,
			speed: 1000,
			autoplaySpeed: 5000,
			autoplay: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		return (
			<Box pt={5} pb={3} id="creators" className={classes.creatorSection}>
				<Container maxWidth="lg">
					<Box
						display="flex"
						className={classes.title}
						justifyContent="center"
					>
						創作者 & 相框
					</Box>
					<Box
						mb={3}
						display="flex"
						justifyContent="center"
						className={classes.subTitle}
					>
						The Creators of MEMOPRESSO
					</Box>

					<Box display="flex" justifyContent="center" mt={5}>
						<Button
							variant="contained"
							color="primary"
							style={{
								width: 150,
								height: 40,
								fontSize: 18,
								borderRadius: 8,
								backgroundColor: "#ff84aa",
							}}
							size="large"
							onClick={() => {
								window.open(
									`https://creator.memopresso.com/`,
									"_blank"
								);
							}}
						>
							立即製作
						</Button>
					</Box>

					<Box
						py={5}
						display={{ xs: "none", sm: "block", md: "block" }}
					>
						<Grid container spacing={3}>
							{_.map(
								creators,
								({ logo, name, link_name, imp }, index) => (
									<Grid
										item
										xs={12}
										sm={4}
										md={3}
										key={`creator_${index}`}
										style={{
											marginBottom: 12,
										}}
									>
										<CreatorCard
											src={logo}
											name={name}
											link={link_name}
											impression={imp}
										/>
									</Grid>
								)
							)}
						</Grid>
					</Box>

					<Box
						py={5}
						display={{ xs: "block", sm: "none", md: "none" }}
					>
						<Slider {...settings}>
							{_.map(
								creators,
								({ logo, name, link_name, imp }, index) => (
									<Grid
										item
										xs={12}
										sm={4}
										md={3}
										key={`creator_${index}`}
										style={{
											marginBottom: 12,
										}}
									>
										<CreatorCard
											src={logo}
											name={name}
											link={link_name}
											impression={imp}
										/>
									</Grid>
								)
							)}
						</Slider>
					</Box>
				</Container>
			</Box>
		);
	};

	const renderCalc = () => {
		return (
			<Box py={5} className={classes.calcSection}>
				<Container maxWidth="lg">
					<Box
						display="flex"
						justifyContent="center"
						className={classes.title}
					>
						創造回憶數量
					</Box>
					<Box
						display="flex"
						className={classes.subTitle}
						justifyContent="center"
					>
						The Memories
					</Box>

					<Grid container style={{ marginTop: 48 }} spacing={3}>
						<Grid item xs={12} sm={6} md={4}>
							{renderCounterCard(100, "K+", "每月接觸人流數")}
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							{renderCounterCard(100, "萬+", "2019回憶列印數")}
						</Grid>
						<Grid item xs={12} sm={6} md={4}>
							{renderCounterCard(160, "K+", "LINE會員人數")}
						</Grid>
					</Grid>
					{/* <Grid container style={{ marginTop: 96 }} spacing={3}>
						<Grid
							item
							xs={12}
							sm={6}
							md={6}
							style={{ minHeight: 300 }}
						>
							<iframe
								width={"100%"}
								height={"100%"}
								src="https://www.youtube.com/embed/1OdsOFL82N0"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Box
								mb={3}
								display="flex"
								style={{
									fontSize: 32,
									fontWeight: 400,
								}}
								justifyContent="center"
							>
								MEMOPRESSO in Korea
							</Box>
							<Box
								display="flex"
								mx={3}
								style={{
									fontSize: 18,
									fontWeight: 200,
								}}
								justifyContent="center"
							>
								「韩国旅行」思い出もインスタ映え♡インスタ画像をオシャレに印刷！
							</Box>
							<Box display="flex" justifyContent="center" mt={5}>
								<Button
									variant="contained"
									color="primary"
									size="large"
									onClick={() => {
										window.open(
											`https://www.instagram.com/memopressokorea/`,
											"_blank"
										);
									}}
								>
									<InstagramIcon style={{ marginRight: 8 }} />
									MEMOPRESSO KOREA
								</Button>
							</Box>
						</Grid>
					</Grid> */}
				</Container>
			</Box>
		);
	};

	const renderAbout = () => {
		return (
			<Box py={5} id="about" className={classes.aboutSection}>
				<Container maxWidth="lg">
					<Box
						display="flex"
						justifyContent="center"
						className={classes.title}
					>
						關於 MEMOPRESSO
					</Box>
					<Box
						display="flex"
						className={classes.subTitle}
						justifyContent="center"
					>
						About MEMOPRESSO
					</Box>

					<Box display="flex" justifyContent="center" mt={3}>
						<div className={classes.desc}>
							MEMOPRESSO 成立於
							2017年，透過個性化社群軟體與無人零售的技術，打造線下到線上融合（Offline-Merge-Online）
							的個性化社群快印網路，滿足21世代創造個性化回憶與保存的需求。
						</div>
					</Box>

					<Grid container style={{ marginTop: 48 }} spacing={3}>
						<Grid item xs={12} sm={6} md={6}>
							<Tooltip
								arrow
								classes={{
									tooltip: classes.noMaxWidth,
								}}
								disableFocusListener={screenWidth < 600}
								disableHoverListener={screenWidth < 600}
								disableTouchListener={screenWidth < 600}
								title={
									<React.Fragment>
										<div className={classes.toolTipStyle}>
											{_.map(aboutTxt1, (txt, index) => (
												<Box
													key={`abountTxt1_${index}`}
													display="flex"
													justifyContent="center"
												>
													{txt}
												</Box>
											))}
										</div>
									</React.Fragment>
								}
							>
								<div>
									<Img
										className={classes.image}
										placeholder={About1}
										src={About1}
										error={About1}
										alt={`有感社交`}
									/>
								</div>
							</Tooltip>

							{/* 手機版文字 */}
							<Box
								mt={2}
								display={{
									xs: "block",
									sm: "none",
									md: "none",
								}}
							>
								{_.map(aboutTxt1, (txt, index) => (
									<Box
										key={`abountTxt1_${index}`}
										display="flex"
										justifyContent="center"
									>
										{txt}
									</Box>
								))}
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Box mb={2}>
								<Tooltip
									arrow
									placement="top-start"
									disableFocusListener={screenWidth < 600}
									disableHoverListener={screenWidth < 600}
									disableTouchListener={screenWidth < 600}
									classes={{
										tooltip: classes.noMaxWidth,
									}}
									title={
										<React.Fragment>
											<div
												className={classes.toolTipStyle}
											>
												{_.map(
													aboutTxt2,
													(txt, index) => (
														<Box
															key={`aboutTxt2_${index}`}
															display="flex"
															justifyContent="center"
														>
															{txt}
														</Box>
													)
												)}
											</div>
										</React.Fragment>
									}
								>
									<div>
										<Img
											className={classes.image}
											placeholder={About2}
											src={About2}
											error={About2}
											alt={`智慧零售`}
										/>
									</div>
								</Tooltip>

								{/* 手機版文字 */}
								<Box
									mt={2}
									display={{
										xs: "block",
										sm: "none",
										md: "none",
									}}
								>
									{_.map(aboutTxt2, (txt, index) => (
										<Box
											key={`abountTxt2_${index}`}
											display="flex"
											justifyContent="center"
										>
											{txt}
										</Box>
									))}
								</Box>
							</Box>
							<Tooltip
								arrow
								placement="top-start"
								disableFocusListener={screenWidth < 600}
								disableHoverListener={screenWidth < 600}
								disableTouchListener={screenWidth < 600}
								classes={{
									tooltip: Clsx(
										classes.noMaxWidth,
										classes.toolTipLight
									),
									arrow: classes.arrow,
								}}
								title={
									<React.Fragment>
										<div className={classes.toolTipStyle}>
											<Img
												className={classes.image}
												placeholder={BrandList}
												src={BrandList}
												error={BrandList}
												alt={`合作品牌`}
											/>
										</div>
									</React.Fragment>
								}
							>
								<div>
									<Img
										className={classes.image}
										placeholder={About3}
										src={About3}
										error={About3}
										alt={`落地各大商場`}
									/>
								</div>
							</Tooltip>

							<Box
								mt={2}
								display={{
									xs: "block",
									sm: "none",
									md: "none",
								}}
							>
								<Img
									className={classes.image}
									placeholder={BrandList}
									src={BrandList}
									error={BrandList}
									alt={`合作品牌`}
								/>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		);
	};

	const renderContact = () => {
		return (
			<Box p={5} id="contact" className={classes.contactSection}>
				<Box
					display="flex"
					className={classes.title}
					style={{ color: "white" }}
					justifyContent="center"
				>
					聯絡我們
				</Box>
				<Box
					mb={3}
					display="flex"
					justifyContent="center"
					className={classes.subTitle}
					style={{ color: "white" }}
				>
					Contact Us
				</Box>

				<Box
					display="flex"
					justifyContent="center"
					className={classes.contactDesc}
					mb={3}
				>
					如果您有任何問題或商業合作需求
					<br />
					請留下您的訊息，我們會在第一時間聯繫您
				</Box>

				<Box display="flex" justifyContent="center">
					<div className={classes.contactContainer}>
						<Grid container spacing={1} style={{ marginBottom: 8 }}>
							<Grid item xs={12} sm={6} md={6}>
								<TextField
									className={classes.inputField}
									id="outlined-basic"
									onChange={(e) =>
										handleChange(e, mailFields.name)
									}
									label="姓名"
									variant="outlined"
								/>
							</Grid>
							<Grid item xs={12} sm={6} md={6}>
								<TextField
									className={classes.inputField}
									id="outlined-basic"
									onChange={(e) =>
										handleChange(e, mailFields.phone)
									}
									label="手機或市話"
									variant="outlined"
								/>
							</Grid>
						</Grid>
						<TextField
							className={classes.inputField}
							style={{ marginBottom: 8 }}
							id="outlined-basic"
							onChange={(e) => handleChange(e, mailFields.email)}
							label="Email"
							variant="outlined"
						/>
						<TextField
							rows={4}
							className={classes.inputField}
							id="outlined-basic"
							label="想告訴我們的話..."
							onChange={(e) =>
								handleChange(e, mailFields.content)
							}
							multiline
							variant="outlined"
						/>
						<Box mt={3} display="flex" justifyContent="center">
							<Button
								variant="contained"
								color="primary"
								size="large"
								onClick={() => sendMail()}
							>
								送出訊息
							</Button>
						</Box>
					</div>
				</Box>
			</Box>
		);
	};

	const renderSiteMap = () => {
		return (
			<Box py={5} id="sitemap" className={classes.mapSection}>
				<Container maxWidth="md">
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6} md={6}>
							<Typography variant="h5" className={classes.title}>
								MEMOPRESSO 點位圖
							</Typography>

							<div className={classes.subTitle}>
								Site Map of MEMOPRESSO
							</div>
							<Box mt={5}>
								<Typography variant="body1">
									不只是台灣，Memopresso遍佈亞洲數個城市，
									<br />
									例如：首爾、釜山、曼谷、吉隆坡等
								</Typography>
							</Box>

							<Box mt={5}>
								<Typography variant="body1">
									<div>South Korea- Seoul & Busan</div>
									<div>Thailand- Bangkok</div>
									<div>Malaysia- Kuala Lumpur</div>
								</Typography>
							</Box>

							<Box mt={5} display="flex" justifyContent="center">
								<Button
									variant="contained"
									color="primary"
									size="large"
									style={{ padding: 16, minWidth: 150 }}
									onClick={() => {
										window.open(
											`https://www.google.com/maps/d/u/0/viewer?mid=1E4FUYFZw0hUx6bYnFh8v6_zGTBT_hWbY&ll=23.58114425375042%2C121.20263837778457&z=8`,
											"_blank"
										);
									}}
								>
									詳細點位圖
								</Button>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Img
								className={classes.image}
								placeholder={SiteMap}
								src={SiteMap}
								error={SiteMap}
								alt={`點位圖`}
							/>
						</Grid>
					</Grid>
				</Container>
			</Box>
		);
	};

	const renderCounterCard = (number = 0, unit = "", desc = "") => {
		return (
			<Paper elevation={3}>
				<Box p={3}>
					<Box display="flex" justifyContent="center">
						<div>
							<span style={{ fontSize: 96, fontWeight: 900 }}>
								<VisibilitySensor>
									{({ isVisible }) => (
										<span>
											{isVisible ? (
												<CountUp end={number} />
											) : (
												number
											)}
										</span>
									)}
								</VisibilitySensor>
							</span>
							<span
								style={{
									verticalAlign: "text-bottom",
									fontSize: 36,
									color: "#a4a4a4",
								}}
							>
								{unit}
							</span>
						</div>
					</Box>
					<Box display="flex" justifyContent="center">
						<div style={{ fontSize: 24, fontWeight: 100 }}>
							{desc}
						</div>
					</Box>
				</Box>
			</Paper>
		);
	};

	return (
		<>
			<Header />
			{/* 首圖 */}
			{renderHome()}
			{/* 產品圖 */}
			{renderProds()}
			{/* 統計數字 */}
			{renderCalc()}
			{/* 操作說明 */}
			{renderOperation()}
			{/* 插畫家相框 */}
			{renderCreators()}
			{/* 關於 */}
			{renderAbout()}
			{/* 聯絡我們 */}
			{renderContact()}
			{/* 點位圖 */}
			{renderSiteMap()}
			<Footer />
		</>
	);
};

export default Home;
